import { SupportFormMediaType } from "../types/SupportFormModel";

export const ACCEPTABLE_MEDIA_TYPES: SupportFormMediaType[] = [
  { extension: ".png", type: "image/png" },
  { extension: ".jpg", type: "image/jpeg" },
  { extension: ".jpeg", type: "image/jpeg" },
  { extension: ".gif", type: "image/gif" },
  { extension: ".bmp", type: "image/bmp" },
  { extension: ".tiff", type: "image/tiff" },
  { extension: ".mp4", type: "video/mp4" },
  { extension: ".avi", type: "video/x-msvideo" },
  { extension: ".mov", type: "video/quicktime" },
  { extension: ".wmv", type: "video/x-ms-wmv" },
];

export const MAX_UPLOAD_SIZE = 50000000;
